import React, { useState, useEffect } from "react";
import { Container, Row, Col, Tab, Nav, Form, Button } from "react-bootstrap";
import ReactSlider from "react-slider";
import { useLocation } from "react-router-dom"; // <-- for reading URL params
import Sidebar from "./Sidebar";
import axios from "axios";
import { useProfile } from "../contexts/ProfileContext";
import { API_BASE_URL } from '../config/api';
import axiosClient from "../api/axiosClient";
import Alert from "./Alert";

const ToolsProfile = () => {
	const profile = useProfile();
	const [username, setUsername] = useState(profile.instagram);
	const [generating, setGenerating] = useState(false);
	const [ideas, setIdeas] = useState([]);
	const [functionError, setFunctionError] = useState("");
	const [functionSuccess, setFunctionSuccess] = useState("");
	

	const scanProfile = async () => {

		try {
			const formData = {};
			formData.age = profile?.socials?.[profile?.selectedProfile]?.ageRange;
			formData.gender = profile?.socials?.[profile?.selectedProfile]?.genderTarget;
			formData.country = profile?.socials?.[profile?.selectedProfile]?.countries;
			formData.niche = profile?.socials?.[profile?.selectedProfile]?.interests;

			formData.username =username;
			setIdeas([]);
			setGenerating(true);

		
			const response = await axiosClient.post("https://api.viralgpt.com/tools/profile", formData, {
			headers: {
				"Content-Type": "application/json",
			},
			});
			setGenerating(false);
			setIdeas(response.data.reply);
			setFunctionSuccess("Suggestions generated successfully.");
		} catch (e) {
			setGenerating(false);
			setFunctionError("An error occurred while scanning profile: " + e.response.data.error);
			
		}
	};


  return (
	<>
		<div className="bg-white border p-6">
              <h5>Profile Enhancer</h5>
              <p className="text-muted">Enter your username and get feedback on how to improve your profiles appearance for maximum virality.</p>

				<Alert 
					variant="danger" 
					message={functionError} 
					show={!!functionError} 
					onClose={() => setFunctionError("")} 
				/>
				
				<Alert 
					variant="success" 
					message={functionSuccess} 
					show={!!functionSuccess} 
					onClose={() => setFunctionSuccess("")} 
				/>

              {/* Link Input */}
              <Form.Group controlId="commentsLink" className="mb-3">
                <Form.Label>Username</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </Form.Group>

              {/* Start Delivery Button */}
              <div className="d-flex align-items-center">
                <Button className={generating ? "disabled bg-instagram" : "bg-instagram"} onClick={() => scanProfile()}>
                  Scan Profile
                </Button>
                <div style={{fontSize: "1.5rem"}} className={`ms-2 fa fa-circle-notch fa-spin text-instagram ${!generating ? "d-none" : ""}`}/>
              </div>

			  
			  
				<div className="mt-3">
					{ideas.map((idea, index) => (
						<div
						key={index}
						style={{
							display: "flex",
							alignItems: "center",  // Ensures vertical centering in flex container
							marginBottom: "1rem",  // Optional spacing between rows
						}}
						>
						<button
							style={{ marginRight: "1rem" }} // Space between button & text
						>
							{index == 0 ? <i className="fa fa-image  text-instagram"></i> : index == 1 ? <i className="fa fa-video text-instagram"></i> : <i className="fa fa-book text-instagram"></i>}
							

							

							


						</button>
						<p style={{ margin: 0 }}>{idea}</p> 
						</div>
					))}
				</div>
				</div>

	</>
  );
};

export default ToolsProfile;
